import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { showPriceProductPage } from '../../../../utils';
import { COURSE_DIRECT_PATH, GUEST_PATH, SELLING_GROUP_PACKAGE_TRAINING_LEVEL_LABEL } from '../../../../constants';

import { CenterSpinner } from '../../../General/Loadings';

const DesignationPackage = (props) => {
     const { loading, packages } = props;

     const bookGroupStagingId = '1474c330-5fca-4e56-a13b-04dfc0b06e88-1655957150689';
     const bookGroupDevId = 'ee211610-1156-2d0f-9e85-cdfea89d10f1-8b531d9f4fa15';
     const bookGroupLocalId = '9901127a-7db9-4552-a12a-10a1b2060a16-1661131213291';
     const thirdBookGroupLiveId = 'e1a34da3-a6a5-45e2-8aa2-b6ea9381e66e-1688392661899';
     const bookGroupIds = [bookGroupStagingId, bookGroupDevId, bookGroupLocalId, thirdBookGroupLiveId];

     const handleClickPurchaseOption = () => {
          localStorage.removeItem(COURSE_DIRECT_PATH);
     };

     if (!loading && !packages.length) return null;

     return (
          <section className="section-designation-package">
               <div className="space-60 space-mb-30"></div>
               <div className="container">
                    <h2 className="designation-package-title">CAMS Designations Packages</h2>
                    {loading && <CenterSpinner classNameWrap="my-5" />}
                    {!loading && (
                         <div className="row">
                              {packages.map((item) => {
                                   const isBookGroup = bookGroupIds.includes(item.id);

                                   const trainingLevel = item.trainingLevels.length
                                        ? SELLING_GROUP_PACKAGE_TRAINING_LEVEL_LABEL[item.trainingLevels[0]]
                                        : '';

                                   return (
                                        <div key={item.id} className="col-md-6 col-xl-4">
                                             <div className="designation-package-box">
                                                  <div className="designation-package-box-left">
                                                       <h3
                                                            className="designation-package-box-title"
                                                            dangerouslySetInnerHTML={{ __html: item.packageTitle }}
                                                       />
                                                       <div className="designation-package-box-img">
                                                            <img src={item.packageImage} alt={item.packageTitle} width={80} height={80} />
                                                       </div>
                                                       {trainingLevel && <p className="designation-package-box-training-level">{trainingLevel}</p>}
                                                  </div>
                                                  <div className="designation-package-box-right">
                                                       <span
                                                            className="designation-package-box-range-price"
                                                            dangerouslySetInnerHTML={{
                                                                 __html: showPriceProductPage({
                                                                      listProduct: item.products,
                                                                      isBookGroup,
                                                                      priceOnly: true,
                                                                 }),
                                                            }}
                                                       />
                                                       <Link
                                                            to={GUEST_PATH.SELLING_GROUPS_DETAIL.replace(':slug', item.slug)}
                                                            className="btn btn-primary btn-primary-v2 designation-package-box-btn"
                                                            onClick={handleClickPurchaseOption}
                                                       >
                                                            <span>Purchase Options</span>
                                                            <svg
                                                                 width="16"
                                                                 height="16"
                                                                 viewBox="0 0 16 16"
                                                                 fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                 <path
                                                                      d="M3.33301 8.00033H12.6663M12.6663 8.00033L7.99967 3.33366M12.6663 8.00033L7.99967 12.667"
                                                                      stroke="currentColor"
                                                                      strokeWidth="2"
                                                                      strokeLinecap="round"
                                                                      strokeLinejoin="round"
                                                                 />
                                                            </svg>
                                                       </Link>
                                                  </div>
                                             </div>
                                        </div>
                                   );
                              })}
                         </div>
                    )}
               </div>
               <div className="space-50 space-mb-15"></div>
          </section>
     );
};

DesignationPackage.propTypes = {
     packages: PropTypes.array,
};

DesignationPackage.defaultProps = {
     packages: [],
};

export default DesignationPackage;
